<script>
  import Heading from './Heading'

  export default {
    name: 'LandSubheading',

    extends: Heading,

    props: {
      size: {
        type: String,
        default: 'text-h6 text-md-h5',
      },
      sizeMobile: {
        type: String,
        default: 'text-h6',
      },
      weight: {
        type: String,
        default: 'bold',
      },
    },
  }
</script>
